import {PropertiesPane} from '../components/NodePropertiesPane.jsx'
import TagSelect from '../../SidePanel/RightPanel/PropertiesControllerTagSelect.jsx'
import Model from './ModelBdterm.mjs'

const PropertiesPaneBatchBdterm = (props) => (
    <PropertiesPane
        controllers={
            <>
                <TagSelect prop="termKey" />
            </>
        }

        Model={Model}
        {...props}
    />
)

export default PropertiesPaneBatchBdterm
